
import {getWeixinUserToken} from '@/api/server/wechat'
import {saveItem, getItem, removeItem} from '@/utils/storage'
import {error} from '@/utils/message'

export default {
  name: 'WechatOauthPage',
  mixins: [],
  data () {
    return {
        url: null,
        info: null,
        code: null
    }
  },
  components: {
  },
  computed: {
  },
  methods: {
    _getWeixinUserToken () {
      console.log('_getWeixinUserToken')
      let query = {
        code: this.code
      }
      console.log('query', query)
      getWeixinUserToken(query).then( (res) => {
        console.log('user-res', res)
        // 获取授权之前访问的页面
        let url = getItem('wx_backurl')
        url = decodeURIComponent(url)
        // 删除 返回页面
        removeItem('wx_backurl')
        if (res.code === 200) {
          let rdata = res.data
          // 保存token
          let userinfo = rdata.user
          userinfo.isLogin = true
          userinfo.token = rdata.token
          saveItem('userinfo', JSON.stringify(userinfo))
          console.log('url-new', url)
          this.$router.push(url)
        } else {
          console.log('授权失败', res)
          error(res.message)
          this.$router.push("/")
        }
      })
    },
    reset () {
      this._getWeixinUserToken()
    },
    handleRoute (route) {
      if (route.name === 'wechat-user') {
        this.code = this.$route.query.code
        console.log('wechat-user')
        console.log('code', this.code)
        this.reset()
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
  
}